import Vue from 'vue'
import Router from 'vue-router'
import VueAnalytics from 'vue-analytics'
import Home from '@/views/Home.vue'

import Login from '@/views/auth/Login'
import Register from '@/views/auth/Register'
import RegistrationComplete from '@/views/auth/RegistrationComplete'
import ForgotPassword from '@/views/auth/ForgotPassword'
import ResetPasswordMigration from '@/views/auth/ResetPasswordMigration'
import NewPassword from '@/views/auth/NewPassword'
import ConfirmEmail from '@/views/auth/ConfirmEmail'
import AcceptInivtation from '@/views/auth/AcceptInvitation'

import EbookDomesticViolence from '@/views/products/EbookDomesticViolence'
import EbookMentalHealth from '@/views/products/EbookMentalHealth'
import EbookNarcissist from '@/views/products/EbookNarcissist'
import EbookRelationshipEnds from '@/views/products/EbookRelationshipEnds'
import Ebook100WaysToSave from '@/views/products/Ebook100WaysToSave'
import FormSeparationStatement from '@/views/products/FormSeparationStatement'
import Checklist from '@/views/products/Checklist'
import FormBindingChildSupportAgreement from '@/views/products/FormBindingChildSupportAgreement'
import FormParentingPlan from '@/views/products/FormParentingPlan'
import BudgetTool from '@/views/products/BudgetTool'

import Account from '@/views/accounts/Account'
import VendorList from '@/views/vendor/VendorList'
import VendorAccounts from '@/views/vendor/VendorAccounts'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { requiresAuth: true }
    },
    { path: '/login', name: 'Login', component: Login },
    { path: '/register', name: 'Register', component: Register },
    { path: '/registration/complete', name: 'Register Confirmation', component: RegistrationComplete },
    { path: '/forgot-password', name: 'Forgot Password', component: ForgotPassword },
    { path: '/reset-password-notification', name: 'Reset Password Migration', component: ResetPasswordMigration },
    { path: '/reset-password/:hash', name: 'New Password', component: NewPassword },
    { path: '/email-confirmation/:hash', name: 'Confirm Email', component: ConfirmEmail },
    { path: '/invitation/:hash', name: 'Accept Invitation', component: AcceptInivtation },
    { path: '/account', name: 'My Account', component: Account, meta: { requiresAuth: true } },
    { path: '/vendors', name: 'vendors', component: VendorList, meta: { requiresAuth: true } },
    { path: '/vendors/:id/accounts', name: 'vendor', component: VendorAccounts, meta: { requiresAuth: true } },
    { path: '/ebooks/domestic-violence', name: 'EbookDomesticViolence', component: EbookDomesticViolence, meta: { requiresAuth: true } },
    { path: '/ebooks/mental-health', name: 'EbookMentalHealth', component: EbookMentalHealth, meta: { requiresAuth: true } },
    { path: '/ebooks/how-to-separate-from-a-narcissist', name: 'EbookNarcissist', component: EbookNarcissist, meta: { requiresAuth: true } },
    { path: '/ebooks/how-to-separate-when-relationship-ends', name: 'EbookRelationshipEnds', component: EbookRelationshipEnds, meta: { requiresAuth: true } },
    { path: '/ebooks/how-to-separate-100-ways-to-save-at-home', name: 'Ebook100WaysToSave', component: Ebook100WaysToSave, meta: { requiresAuth: true } },
    { path: '/products/checklists', name: 'Checklist', component: Checklist, meta: { requiresAuth: true } },
    { path: '/products/separation-statement', name: 'FormSeparationStatement', component: FormSeparationStatement, meta: { requiresAuth: true } },
    { path: '/products/binding-child-support-agreement', name: 'FormBindingChildSupportAgreement', component: FormBindingChildSupportAgreement, meta: { requiresAuth: true } },
    { path: '/products/parenting-plan', name: 'FormParentingPlan', component: FormParentingPlan, meta: { requiresAuth: true } },
    { path: '/products/budget-tool', name: 'BudgetTool', component: BudgetTool, meta: { requiresAuth: true } },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  // const publicPages = ['/login', '/register', '/registration/complete']
  // const authRequired = !publicPages.includes(to.path)

  // var jwt = window.localStorage.getItem('id_token')
  // console.log('auth-guard :: id_token = ' + jwt)
  // var userLoggedIn = jwt !== null && jwt !== 'undefined' && jwt !== ''
  // if (authRequired && !userLoggedIn) {
  //   next('/login')
  // } else {
  //   next()
  // }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('jwt') == null) {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath } // FIXME: this line has no effect for some reason
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

Vue.use(VueAnalytics, {
  id: 'UA-91470511-3',
  router
})

export default router
